import React, { CSSProperties, useState } from "react";
import DateControl from "../../../components/Fields/DateControl";
import Field from "../../../components/Fields/Field";
import { FieldProps } from "../../../components/Fields/Types";
import ProjectMilestoneModel from "../../../models/ProjectMilestoneModel";
import FormatUtils from '../../../utils/FormatUtils.js';

interface MilestoneFieldProps extends FieldProps {
    milestone: ProjectMilestoneModel
}

const ProjectMilestoneField: React.FC<MilestoneFieldProps> = ({ labelProps, controlProps, milestone }) => {
    const [projectMilestone, setMilestone] = useState<ProjectMilestoneModel>(milestone)
    const formatUtils = new FormatUtils();

    const outerStyle: CSSProperties = {
        minWidth: 115,
        fontWeight: 'bold',
        fontSize: 15,
        marginTop: 6
    };
    const missedStyle: CSSProperties = {
        width: 35,
        height: 28,
        border: '2px solid black',
        float: 'right',
        padding: 2,
        backgroundColor: 'Red',
        textAlign: 'right'
    };
    const lateStyle: CSSProperties = {
        width: 35,
        height: 28,
        border: '2px solid black',
        float: 'right',
        padding: 2,
        backgroundColor: 'Orange',
        textAlign: 'right'
    };
    const ontimeStyle: CSSProperties = {
        width: 35,
        height: 28,
        border: '2px solid black',
        float: 'right',
        padding: 2,
        backgroundColor: 'Green',
        textAlign: 'right'
    };
    const projectMilestoneStyle: CSSProperties = {
        width: 105,
        height: 28,
        border: '2px solid black',
        float: 'right',
        padding: 2,
        backgroundColor: milestone.color,
        textAlign: 'center'
    };

    function onControlChange(val: string) {
        controlProps.onChange(val);
    }

    return (
        <Field {...labelProps}>
            <DateControl {...controlProps} onChange={onControlChange} />
            {projectMilestone.milestoneTypeId == 1 && (
                <div style={outerStyle}>
                    <div style={projectMilestoneStyle}>{formatUtils.formatDate(projectMilestone.achievedOn)}</div>
                </div>
            )}
            {projectMilestone.milestoneTypeId != 1 && (
                <div style={outerStyle}>
                    <div className='aligncenter' style={missedStyle}>{projectMilestone.milestonesMissed}</div>
                    <div className='aligncenter' style={lateStyle}>{projectMilestone.milestonesLate}</div>
                    <div className='aligncenter' style={ontimeStyle}>{projectMilestone.milestonesOnTime}</div>
                </div>
            )}
        </Field>
    );
}
export default ProjectMilestoneField;